export default __webpack_public_path__ + "static/article-ways-to-instantly-boost-your-savings-v1-db8782aacaf6b4e483cff2fd69ef0024.jpg";